<template>
  <v-container>
    <div class="title-icon">
      <h1>{{ $t("ebook.apprentice-report") }}</h1>
      <v-btn icon :href="links.ebook.instructorInfo" target="_blank">
        <v-icon>$sl-question</v-icon>
      </v-btn>
    </div>

    <v-form ref="form" lazy-validation>
      <v-autocomplete
        v-model="apprenticeModel"
        :items="apprentices"
        :label="$t('ebook.apprentice-list-title')"
        :rules="[rules.required]"
        item-text="text"
        item-value="bookId"
        item-key="bookId"
        outlined
        return-object
      >
        <template v-slot:item="data">
          <!-- `<th>Person info and book if more then 1</th>` -->
          <div class="d-flex flex-column select__slot__text">
            <div class="select__slot__text--title">{{ data.item.text }}</div>
            <div v-if="apprentices && apprentices.length > 1" class="select__slot__text--subtitile">
              {{ data.item.createdAt }}
            </div>
          </div>
        </template>
      </v-autocomplete>
    </v-form>
    <!-- List of Reports -->
    <!-- PROBABLY WRONG Number(bookId) -->
    <ReportsList
      @reportDetailItem="reportDetailItem"
      :personId="Number(personId)"
      :bookId="Number(bookId)"
    />
  </v-container>
</template>

<script>
import API from "@/services/api.js";
import ReportsList from "@/components/Ebook/Reports/ReportsList";
import { RulesMixin } from "@/components/mixins";
import { mapActions, mapGetters } from "vuex";
import find from "lodash/find";
import sortBy from "lodash/sortBy";

// @group Ebook
// Styled ApprenticesReports component
export default {
  name: "ApprenticesReports",

  mixins: [RulesMixin],

  components: {
    ReportsList,
  },
  data() {
    return {
      links: require('../../../lib/external-links.json'),
      apprenticeModel: null,
      bookId: null,
      personId: -1,
      apprentices: [],
      apprentice: {},
    };
  },
  watch: {
    apprenticeModel(val) {
      if (val && val.bookId) {
        this.bookId = val.bookId;
      } else {
        this.bookId = val;
      }
      if (val && val.personId) {
        this.personId = val.personId;
      } else {
        this.personId = val;
      }

      //this.init();
    },

    $route: {
      handler: function (e) {
        if (this.$route && this.$route.params.apprenticeModel) {
          this.apprenticeModel = this.$route.params.apprenticeModel;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters("currentuser", [
      "currentUser",
      "isInstructor",
      "isCompanyUser",
      "isOnlyInstructor",
    ]),
  },
  methods: {
    init() {
      if (this.currentUser && this.isCompanyUser(0)) {
        this.getApprentices();
      }
    },

    getApprentices() {
      API.listBooks()
        .then((response) => {
          const listBooks = sortBy(response.data || [], [v => v.person.lastName]);
          listBooks.forEach((obj) => {
            if (
              this.isOnlyInstructor &&
              obj.apprenticeship &&
              obj.apprenticeship.apprenticeshipInstructors
            ) {
              const myIds = this.currentUser.employments.map((o) => o.id);
              const appIds = obj.apprenticeship.apprenticeshipInstructors.map(
                (o) => o.instructorId
              );
              const found = appIds.some((r) => myIds.includes(r));
              if (found) {
                this.apprentices.push({
                  text:
                    obj.person.firstName +
                    " " +
                    obj.person.lastName +
                    " (" +
                    obj.person.personalNumber +
                    ")",
                  bookId: obj.id,
                  personId: obj.personId,
                  createdAt:
                  this.$t("ebook.button-label") +
                  " " +
                  this.$options.filters.date(obj.createdAt),
                });
              }
            } else {
              this.apprentices.push({
                text:
                  obj.person.firstName +
                  " " +
                  obj.person.lastName +
                  " (" +
                  obj.person.personalNumber +
                  ")",
                bookId: obj.id,
                personId: obj.personId,
                createdAt:
                  this.$t("ebook.button-label") +
                  " " +
                  this.$options.filters.date(obj.createdAt),
              });
            }           
          });

          if ((this.apprentices.length < 10)) {
            this.apprenticeModel = this.apprentices[0];
          }
          else {
            this.apprenticeModel = null
          }
        })
        .catch((error) => {
          console.log("There was an error:", error.response);
        });
    },
    reportDetailItem(item) {
      this.$nextTick(() => {
        this.$router.push({
          name: "InstructorApprenticesReport",
          params: {
            bookId: item.BookId,
            reportId: item.id,
            apprenticeModel: this.apprenticeModel,
          },
        });
      });
    },
  },
};
</script>
